/* @flow */
import React from 'react';
import styled from 'styled-components';

import { getLabel } from '../../utils/i18n';
import EmptyTable from '../../components/EmptyTable';

const Wrap = styled.div`
.bnc-table th, .bnc-table td {
    padding: 5px 3px;
}
`;


const getOrderNo = (orderNo) => {
  if (orderNo === 1) return <img width="30" src={require('./images/rankingNo_1.svg')} alt={`NO${orderNo}`} />;
  if (orderNo === 2) return <img width="30" src={require('./images/rankingNo_2.svg')} alt={`NO${orderNo}`} />;
  if (orderNo === 3) return <img width="30" src={require('./images/rankingNo_3.svg')} alt={`NO${orderNo}`} />;
  return orderNo;
};


const columns = (i18n, asset) => [
  {
    title: getLabel('exchange-activity-orderNo', i18n),
    dataIndex: 'orderNo',
    align: 'center',
    render(orderNo) {
      return getOrderNo(orderNo);
    },
  },
  {
    title: getLabel('exchange-common-email', i18n),
    dataIndex: 'email',
    align: 'center',
    render(email) {
      return email;
    },
  },
  {
    title: <>{getLabel('exchange-common-tradeVolumn', i18n)} ({asset}) </>,
    dataIndex: 'tradeAmount',
    align: 'right',
    render(tradeAmount) {
      return tradeAmount;
    },
  },
];

type Props = {
  i18n: Object,
  data: Array<Object>,
  asset: string,
};

const RankingTable = ({ i18n, data, asset }: Props) => (
  <Wrap>
    <EmptyTable
      i18n={i18n}
      rowKey="rankingId"
      data={data || []}
      columns={columns(i18n, asset)}
      emptyText={getLabel('exchange-OpenOrdersTable-NoData', i18n)}
      pagination={false}
    />
  </Wrap>
);
RankingTable.defaultProps = {
  i18n: {},
  data: [],
  asset: '',
};
export default RankingTable;
